import {stringColumn, textAreaColumn} from "../../helpers/commonColumns";
import DataType from "../../constants/DataType";

export const softwareProductColumns = () => [
    stringColumn('code', 'Code'),
    stringColumn('name', 'Name'),
    {
        key: 'productVersion',
        dataIndex: 'productVersion',
        title: 'Version',
        type: DataType.TEXT,
        required: true,
        validationRules: [{min: 1}, {max: 50}]
    },
    textAreaColumn('description', 'Description')
];